import React, { useMemo } from 'react';
import {
  SupplierOrganizationBusinessType,
  SupplierOrganizationUnitsActiveType,
} from '@institutions/graphql';
import { groupBy } from 'lodash';
import { Collapse, Col, Row } from '@common/components';
type Props = {
  organizationBusinesses: SupplierOrganizationBusinessType[];
  organizationUnits: SupplierOrganizationUnitsActiveType[];
};

export function SuppliersManagementViewDrawerFacilities({
  organizationBusinesses,
  organizationUnits,
}: Props) {
  const organizationBusinessesWithUnits = useMemo(() => {
    const indexedUnits = groupBy(
      organizationUnits,
      (unit) => unit.organizationBusiness.id
    );

    return organizationBusinesses.map((business) => ({
      organizationBusiness: business,
      organizationUnits: indexedUnits[business.id] || [],
    }));
  }, [organizationBusinesses, organizationUnits]);

  return (
    <>
      <Row gutter={[0, 12]} className="supplier-view-drawer-facilities">
        <Col span={24}>
          <Collapse accordion>
            {organizationBusinessesWithUnits.map(
              ({ organizationBusiness, organizationUnits }) => (
                <Collapse.Panel
                  title={
                    <label className="supplier-view-drawer-facilities__collapse-label">
                      {organizationBusiness.name} ({organizationUnits.length}/
                      {organizationBusiness.organizationUnitsActiveCount})
                    </label>
                  }
                  key={organizationBusiness.id}
                >
                  <ul>
                    {organizationUnits.map((organizationUnit) => (
                      <li
                        key={organizationUnit.id}
                        className="facility-list-item"
                      >
                        {organizationUnit.name}
                      </li>
                    ))}
                  </ul>
                </Collapse.Panel>
              )
            )}
          </Collapse>
        </Col>
      </Row>
      <style jsx>{`
        .facility-list-item:not(:last-child) {
          margin-bottom: 12px;
        }
      `}</style>
    </>
  );
}
